import React, { Fragment } from 'react';
import {
    BulkDeleteButton,
    BooleanField,
    BooleanInput,
    Create,
    Datagrid,
    DateField,
    DeleteButton,
    Edit,
    EditButton,
    List,
    ListButton,
    maxLength,
    minLength,
    RefreshButton,
    required,
    SaveButton,
    SimpleForm,
    TextField,
    TextInput,
    Toolbar,
    TopToolbar,
    ReferenceField,
    ReferenceInput,
    SelectInput,
} from 'react-admin'
import { makeStyles } from '@mui/styles';
import EnableButton from '../Button/EnableButton';
import DisableButton from '../Button/DisableButton';

const createDefaultValues = {
    enabled: false,
};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const validateRequired = [required()];
const validateCampaignName = [required(), minLength(3), maxLength(64)];

const PostEditActions = ({ basePath }) => (
    <TopToolbar>
        <ListButton basePath={basePath} />
        <RefreshButton />
    </TopToolbar>
);

const CustomToolbar = props => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton />
    </Toolbar>
);

const CodeBulkActionButtons = props => (
    <Fragment>
        <EnableButton label="Enable" {...props} />
        <DisableButton label="Disable" {...props} />
        <BulkDeleteButton {...props}/>
    </Fragment>
  );

export const CustomDeleteButton = props => (
    <DeleteButton {...props} mutationMode="pessimistic" />
  );

export const CampaignList = props => (
    <List {...props} bulkActionButtons={<CodeBulkActionButtons />}>
        <Datagrid rowClick="edit">
            <TextField label="Campaign ID" source="id" />
            <ReferenceField label="Channel ID" reference="Channel" source="channelId">
                <TextField source="name" />
            </ReferenceField>
            <TextField label="Name" source="name" />
            <DateField label="Date Created" source="dateCreated" showTime />
            <DateField label="Date Modified" source="dateModified" showTime />
            <BooleanField label="Enabled" source="enabled" />
            <EditButton />
        </Datagrid>
    </List>
);

export const CampaignEdit = props => (
    <Edit actions={<PostEditActions />} {...props}>
        <SimpleForm toolbar={<CustomToolbar />}>
            <ReferenceInput
                label="Select Channel ID"
                source="channelId"
                reference="Channel">
                <SelectInput optionText="name" validate={validateRequired} />
            </ReferenceInput>
            <TextInput
                label="Campaign Name"
                source="name"
                validate={validateCampaignName}
            />
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Edit>
);

export const CampaignCreate = props => (
    <Create actions={<PostEditActions />} {...props}>
        <SimpleForm initialValues={createDefaultValues} redirect="list">
            <ReferenceInput
                label="Select Channel ID"
                source="channelId"
                reference="Channel">
                <SelectInput optionText="name" validate={validateRequired} />
            </ReferenceInput>
            <TextInput
                label="Campaign Name"
                source="name"
                validate={validateCampaignName}
            />
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Create>
);